<template>
  <UIDottedMenu
    ref="menuRef"
    :items
    :size
    class="modal-repositories-item-menu"
  />
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import { ButtonSize, DottedMenuItem } from '@types'

import { UIDottedMenu } from '@ui/core'

type Props = {
  items: DottedMenuItem[]
  size?: ButtonSize
}

defineProps<Props>()

defineExpose({
  hide() {
    menuRef.value?.hide()
  },
})

const menuRef = useTemplateRef('menuRef')
</script>

<style scoped>
.modal-repositories-item-menu {
  @apply -my-1;
}
</style>
